// extracted by mini-css-extract-plugin
export default {"list":"CityList_list__c-oNE"};